














































































































































































































































































































import { Component, Ref, Watch } from 'nuxt-property-decorator'
import { ModalComponentBaseVue } from '@/base'
import { ModalFooter } from '@/components/molecules/ModalFooter'
import {
  alertStore,
  appStore,
  dataStore,
  modalBibliographyDetailRealStore,
  modalBibliographyDetailSetStore,
  modalBibliographyDetailStore,
  modalBibliographySearchStore,
  modalErrorStore,
  systemParameterStore
} from '@/store'
import {
  AlertMessage,
  bibliographyRealApi,
  BibliographyRealDetail,
  BibliographySearchResultItem,
  BibliographyRealDetailReserve,
  Collection,
  collectionApi,
  defaultBibliographyRealDetail,
  defaultBibliographyRealDetailReserve,
  defaultCollection,
  defaultOrder,
  defaultSystemCode,
  ErrorMessage,
  Order,
  orderApi,
  BibliographyTooli,
  defaultBibliographyTooli,
  SystemCode,
  FirstMarcLabel,
  marcLabelApi,
  BibliographySetDetailVolume,
  BibliographySearchResultContentItem
} from '@/api'
import {
  AlertCodeCLT00050,
  AloneSearchType,
  BibliographyClass,
  BibliographyDetailRealTabType,
  BibliographyDetailSetTabType,
  BibliographyFullIdWithMarcNo,
  BibliographySearchType,
  CollectionStatus,
  OrderIdMaxDigits,
  Prefix,
  ReceiptPrintName,
  SearchType
} from '@/types'
import { BibliographyRealInfo } from '@/components/organisms/BibliographyRealInfo'
import { BibliographyRealInfoMagazine } from '@/components/organisms/BibliographyRealInfoMagazine'
import { BibliographyDetailCollectionTable } from '@/components/organisms/BibliographyDetailCollectionTable'
import CollectionDetailTab, {
  CollectionDetailTabItem,
  defaultCollectionDetailTabItem
} from '@/components/templates/collection-detail/CollectionDetailTab.vue'
import { dateTimeToDateFormat, dateTimeToTimeFormat } from '@/utils'
import CollectionDetailAction from '@/components/templates/collection-detail/CollectionDetailAction.vue'
import SearchResultPagination from '@/components/molecules/SearchResultPagination/SearchResultPagination.vue'
import ModalConfirmationLendCount from '@/components/modals/ModalConfirmationLendCount/ModalConfirmationLendCount.vue'
import CollectionMarcTable from '@/components/templates/collection-marc/CollectionMarcTable.vue'
import CollectionReserveStatusTable from '@/components/templates/collection-reserve-status/CollectionReserveStatusTable.vue'
import CollectionReserveStatusDetail from '@/components/templates/collection-reserve-status/CollectionReserveStatusDetail.vue'
import ModalInputCollectionBookNumber from '@/components/modals/ModalInputCollectionBookNumber/ModalInputCollectionBookNumber.vue'
import ModalRegistrationInfoEdit from '@/components/modals/ModalRegistrationInfoEdit/ModalRegistrationInfoEdit.vue'
import BibliographyDetailTooliInfo from '@/components/organisms/BibliographyDetailTooliInfo/BibliographyDetailTooliInfo.vue'
import BibliographyRealDetailContent from '@/components/templates/bibliography-real-detail-content/BibliographyRealDetailContent.vue'
import { BibliographyTagDataList } from '@/components/templates/bibliography-tag-data-list'
import {
  BibliographyDetailCollectionTableItem,
  defaultBibliographyDetailCollectionTableItem,
  ShelfTypeItem
} from '@/components/organisms/BibliographyDetailCollectionTable/BibliographyDetailCollectionTable.vue'
import CODE_KEY from '@/config/code_key'
import { ModalSelectionInfo } from '@/components/modals/ModalSelectionInfo'
import { CommandType } from '@/types/websocket'
import { ModalBibliographyRealPrintSelection } from '@/components/modals/ModalBibliographyRealPrintSelection'
import {
  FirstTransitionToBibliographyDetail,
  SecondAfterTransitionToBibliographyDetail
} from '@/store/BibliographyDetailStore'
import { ModalChildCollectionList } from '@/components/modals/ModalChildCollectionList'
import { AlertFactory } from '@/factory'

@Component({
  components: {
    ModalChildCollectionList,
    ModalBibliographyRealPrintSelection,
    ModalSelectionInfo,
    BibliographyRealDetailContent,
    BibliographyDetailTooliInfo,
    ModalConfirmationLendCount,
    ModalRegistrationInfoEdit,
    CollectionReserveStatusDetail,
    ModalInputCollectionBookNumber,
    SearchResultPagination,
    CollectionReserveStatusTable,
    CollectionMarcTable,
    CollectionDetailAction,
    CollectionDetailTab,
    ModalFooter,
    BibliographyRealInfo,
    BibliographyRealInfoMagazine,
    BibliographyDetailCollectionTable,
    BibliographyTagDataList
  }
})
export default class ModalBibliographyDetailReal extends ModalComponentBaseVue {
  @Ref()
  modalConfirmationLendCount!: ModalConfirmationLendCount

  @Ref()
  modalInputCollectionBookNumber!: ModalInputCollectionBookNumber

  @Ref()
  modalRegistrationInfoEdit!: ModalRegistrationInfoEdit

  @Ref()
  modalSelectionInfo!: ModalSelectionInfo

  @Ref()
  modalBibliographyRealPrintSelection!: ModalBibliographyRealPrintSelection

  @Ref()
  modalChildCollectionList!: ModalChildCollectionList

  collectionType: string = ''

  activeTab: BibliographyDetailRealTabType =
    BibliographyDetailRealTabType.Collection

  tabItem: CollectionDetailTabItem = defaultCollectionDetailTabItem()

  collection: Collection = defaultCollection()

  order: Order = defaultOrder()

  selectedReserve: BibliographyRealDetailReserve = defaultBibliographyRealDetailReserve()

  bibliographyRealDetail: BibliographyRealDetail = defaultBibliographyRealDetail()

  selectedCollection: BibliographyDetailCollectionTableItem = defaultBibliographyDetailCollectionTableItem()

  tableBodyHeight: number = 0

  tabHeight: number = 0

  tooliInfo: BibliographyTooli = defaultBibliographyTooli()

  realFirstMarcLabels: FirstMarcLabel[] = []

  tooliMarcNo: string = ''

  userId: string = ''

  contentId: number = 0

  get tabType(): any {
    return BibliographyDetailRealTabType
  }

  get isRegisteredBibliography() {
    return this.bibliographyRealDetail.bibliography.bibliographyId > 0
  }

  get tooliSearchEnabled() {
    return this.tooliMarcNo !== ''
  }

  get collectionTableItems(): BibliographyDetailCollectionTableItem[] {
    let tableItems: BibliographyDetailCollectionTableItem[] = this.bibliographyRealDetail.collections
      .map(collection => {
        return {
          isOrder: false,
          ...collection
        }
      })
      .concat(
        this.bibliographyRealDetail.orders.map(order => {
          return {
            isOrder: true,
            id: order.id,
            collectionNo: String(order.id), // 間違いではない、表示値は発注ID
            holdingBranchCode: order.holdingBranchCode,
            callNo: order.callNo,
            shelfType: order.shelfType,
            collectionType: order.collectionType,
            status: order.status,
            handlingType: order.handlingType,
            appendixCode: order.appendixCode,
            dueDate: '',
            processedDate: order.processedDate,
            processedBranchCode: order.processedBranchCode,
            forwardingBranchCode: defaultSystemCode(),
            userId: '',
            workMemo: order.workMemo,
            displayMemo: order.displayMemo,
            localMemo: order.localMemo,
            appendixLendFlag: false,
            revision: order.revision,
            childCollectionCount: 0,
            traderCode: order.traderCode,
            acceptType: order.acceptType,
            orderPrice: order.orderPrice
          }
        })
      )

    if (!this.isDisplayRemoved) {
      // orderStatusと異なる形式なので成り立っている。仕様が変わることは無いと判断してそのまま使用
      tableItems = tableItems.filter(
        item => item.status.code !== CollectionStatus.Removed
      )
    }

    return tableItems
  }

  get disabledSelectButton(): boolean {
    return this.isCollectionSelect && this.collectionTableItems.length === 0
  }

  get orderIdMaxDigits(): number {
    return OrderIdMaxDigits
  }

  get existsCollection(): boolean {
    this.calculateTableHeight()
    return this.collection.id !== 0
  }

  get existsOrder(): boolean {
    this.calculateTableHeight()
    return this.order.id !== 0
  }

  get isOrder(): boolean {
    return this.selectedCollection.isOrder
  }

  get isOpen() {
    return modalBibliographyDetailRealStore.isOpen
  }

  get showPagination(): boolean {
    return (
      this.isSearched &&
      modalBibliographyDetailStore.showPagination &&
      this.searchResultsCount !== 0
    )
  }

  get isSearched(): boolean {
    return this.isBibliographySelectProcess || this.isCollectionSelect
  }

  get isCollectionSelect(): boolean {
    return modalBibliographyDetailRealStore.isCollectionSelect
  }

  get isBibliographySelectProcess(): boolean {
    return modalBibliographyDetailRealStore.isBibliographySelectProcess
  }

  get initialTabType(): BibliographyDetailRealTabType {
    return modalBibliographyDetailRealStore.tabType
  }

  get isHitTwoMoreLessResultsAuthority(): boolean {
    return modalBibliographySearchStore.authorityItems.length < 2
  }

  get isHitOneSearchResults(): boolean {
    return modalBibliographySearchStore.total === 1
  }

  get isHitOneSearchResultsContent(): boolean {
    return modalBibliographySearchStore.contentItems.length === 1
  }

  get tabStyles(): object {
    if (this.fontSizeType === 'normal') {
      return {}
    }

    return {
      'font-size': this.fontSize + 'px'
    }
  }

  get fontSize(): number {
    return appStore._fontSizeNormal
  }

  get fontSizeType(): string {
    return appStore._fontSizeType
  }

  get searchType(): SystemCode {
    return this.bibliographyRealDetail.bibliography.searchType
  }

  get pageIsBook() {
    return this.searchType.code === SearchType.Book
  }

  get pageIsAv() {
    return this.searchType.code === SearchType.Av
  }

  get pageIsMagazine() {
    return this.searchType.code === SearchType.Magazine
  }

  get paginationTitle(): string {
    if (
      this.pageIsMagazine &&
      [
        SecondAfterTransitionToBibliographyDetail.VolumePagination,
        SecondAfterTransitionToBibliographyDetail.Set
      ].includes(this.secondAfterTransitionSource)
    ) {
      return '巻号一覧'
    } else if (this.isContentSearch) {
      return '内容一覧'
    }

    return '検索結果一覧'
  }

  get pageTitle() {
    if (this.pageIsBook) {
      return '資料の管理：照会（図書）'
    }

    if (this.pageIsAv) {
      return '資料の管理：照会（ＡＶ）'
    }

    if (this.pageIsMagazine) {
      return '資料の管理：照会（雑誌・巻号）'
    }

    return '資料の管理：照会'
  }

  get isContentSearch(): boolean {
    return modalBibliographySearchStore.contentItems.length > 0
  }

  get currentPage(): number {
    return this.currentSearchResultIndex + 1
  }

  get currentSearchResultIndex(): number {
    return this.searchResults.findIndex(obj => {
      if (this.tooliSearchEnabled) {
        return (obj as BibliographySearchResultItem).marcNo === this.tooliMarcNo
      }

      if (this.isContentSearch) {
        return (
          (obj as BibliographySearchResultContentItem).bibliographyContentId ===
          this.contentId
        )
      }

      return (
        obj.bibliographyId ===
        this.bibliographyRealDetail.bibliography.bibliographyId
      )
    })
  }

  get searchResultsCount(): number {
    return this.searchResults.length
  }

  get filterSearchResults(): BibliographySearchResultItem[] {
    return modalBibliographySearchStore.filterItems
  }

  get searchResults(): (
    | BibliographySearchResultItem
    | BibliographySetDetailVolume
    | BibliographySearchResultContentItem
  )[] {
    if (
      this.pageIsMagazine &&
      [
        SecondAfterTransitionToBibliographyDetail.VolumePagination,
        SecondAfterTransitionToBibliographyDetail.Set
      ].includes(this.secondAfterTransitionSource)
    ) {
      return modalBibliographyDetailSetStore.volumes
    }

    if (this.isContentSearch) {
      return modalBibliographySearchStore.contentItems
    }

    return this.filterSearchResults
  }

  get tabStyle(): any {
    return this.tabHeight ? { height: this.tabHeight + 'px' } : {}
  }

  get firstTransitionSource(): FirstTransitionToBibliographyDetail {
    return modalBibliographyDetailStore.firstTransitionSource
  }

  get secondAfterTransitionSource(): SecondAfterTransitionToBibliographyDetail {
    return modalBibliographyDetailStore.secondAfterTransitionSource
  }

  get shouldDisplayAutoLibButton(): boolean {
    return dataStore.autoLibEnabled
  }

  get disabledAutoLibButton(): boolean {
    return dataStore.closedShelfTypes.every(
      shelfType => shelfType !== this.selectedCollection.shelfType.code
    )
  }

  get autoLibRetrievalStationCode(): string {
    return dataStore.autoLibRetrievalStationCode
  }

  get displayContentTab(): boolean {
    return dataStore.displayBibliographyDetailContentTab
  }

  get displayRemovedWarnLabel(): boolean {
    return (
      !this.isDisplayRemoved &&
      this.bibliographyRealDetail.collections.some(
        item => item.status.code === CollectionStatus.Removed
      )
    )
  }

  get isDisplayRemoved(): boolean {
    return modalBibliographyDetailStore.isDisplayRemoved
  }

  @Watch('isOpen')
  initialize() {
    if (this.isOpen) {
      systemParameterStore.fetchAllAndMergeByCodeKeys([
        CODE_KEY.NUMBER_MANAGEMENT.KEY, // 予約者番号の0埋めに使用している
        CODE_KEY.RETURN_HISTORY_DISPLAY_ENABLED_SETTING.KEY, // 資料/発注タブ、返却履歴ボタン表示判定で使用
        CODE_KEY.TOOLI_BIBLIOGRAPHY_REGISTER_PARAMETER2.KEY
      ])

      this.tooliMarcNo = modalBibliographyDetailRealStore.marcNo
      this.userId = modalBibliographyDetailRealStore.userId
      this.contentId = modalBibliographyDetailRealStore.bibliographyContentId
      this.fetchData(
        modalBibliographyDetailRealStore.bibliographyRealId,
        modalBibliographyDetailRealStore.marcNo
      ).then(this.fetchBibliographyTooli)
      this.activeTab = this.initialTabType
      window.addEventListener('resize', this.onResize)
      return
    }

    window.removeEventListener('resize', this.onResize)
    this.reset()
  }

  onChangeIsDisplayRemoved(value: boolean) {
    modalBibliographyDetailStore.setIsDisplayRemoved(value)

    if (this.collectionTableItems.length === 0) {
      this.collection = defaultCollection()
      this.order = defaultOrder()
      this.selectedCollection = defaultBibliographyDetailCollectionTableItem()
    } else if (
      this.collectionTableItems.every(
        value => value.id !== this.selectedCollection.id
      )
    ) {
      this.selectedCollection = this.collectionTableItems[0]
      this.searchCollection()
    }
  }

  onFetchedMarcLabel(): void {
    this.$nextTick(this.calculateTableHeight)
  }

  // ダイアログ縦幅を固定としている為、計算方法が他と違う点に注意
  calculateTableHeight() {
    this.tableBodyHeight = 0
    this.tabHeight = 0

    this.$nextTick(() => {
      this.tableBodyHeight = this.calculateTableHeightBase()
      this.tabHeight = this.tableBodyHeight + 22

      if (this.activeTab === BibliographyDetailRealTabType.Bibliography) {
        const bibliographyElements: HTMLCollection | null = document.getElementsByClassName(
          'bibliography-tag-data-list'
        ) as HTMLCollectionOf<HTMLElement>
        this.tableBodyHeight +=
          bibliographyElements[0].children[0].clientHeight -
          bibliographyElements[0].children[1].clientHeight +
          10
      } else if (this.activeTab === BibliographyDetailRealTabType.Content) {
        const contentElements = document.getElementsByClassName(
          'tab-type-content'
        ) as HTMLCollectionOf<HTMLElement>

        this.tableBodyHeight +=
          contentElements[0].children[1].children[0].clientHeight -
          (contentElements[0].children[0].children[0].clientHeight +
            contentElements[0].children[0].children[1].clientHeight) +
          56
      }
    })
  }

  close() {
    modalBibliographyDetailRealStore.close()
  }

  onResize(): void {
    this.calculateTableHeight()
  }

  onClickBackCondition(): void {
    modalBibliographyDetailRealStore.backCondition()
  }

  onClickBackResult(): void {
    modalBibliographyDetailStore.setSecondAfterTransitionSource(
      SecondAfterTransitionToBibliographyDetail.Not
    )
    modalBibliographyDetailRealStore.backResult()
  }

  onClickSelect(): void {
    modalBibliographyDetailRealStore.select({
      prefix: this.bibliographyRealDetail.bibliography.prefix,
      collectionNo: this.isOrder
        ? String(this.selectedCollection.id).padStart(
            this.orderIdMaxDigits,
            '0'
          )
        : this.selectedCollection.collectionNo,
      bibliographyId: this.bibliographyRealDetail.bibliography.bibliographyId,
      marcNo: this.tooliMarcNo
    })
  }

  onClickTab(value: BibliographyDetailRealTabType): void {
    if (value === this.activeTab) {
      return
    }
    this.activeTab = value
    this.$nextTick(this.calculateTableHeight)
  }

  onClickMagazineLink(): void {
    modalBibliographyDetailStore.setSecondAfterTransitionSource(
      SecondAfterTransitionToBibliographyDetail.Volume
    )

    this.onToggleSet(
      this.bibliographyRealDetail.bibliography.bibliographySetId ?? 0
    )
  }

  onClickParentCollectionNoLink(): void {
    // 親資料番号の設定は製本処理でのみ行われる
    // 製本処理ではTOOLi書誌を処理の対象には取らない為、それを踏まえて、TOOLi書誌では親資料番号のリンクは設定されないという前提の元、処理を設定
    modalBibliographyDetailStore.setSecondAfterTransitionSource(
      SecondAfterTransitionToBibliographyDetail.ParentCollectionId
    )
    modalBibliographyDetailStore.setInitialSelectCollectionNo(
      this.collection.parentCollectionNo
    )

    this.fetchData(this.collection.parentBibliographyId, '')
  }

  openModalReturnHistory(): void {
    this.$modalReturnHistory.open({
      collectionId: this.selectedCollection.id,
      collectionNo: this.selectedCollection.collectionNo,
      onClickLinkCallback: (userId: string) => {
        this.openModalUserDetail(userId)
      }
    })
  }

  openModalUserDetail(userId: string): void {
    this.$modalUserDetail.open({
      userId
    })
  }

  onToggleSet(
    bibliographyId: number,
    tabType: BibliographyDetailSetTabType = BibliographyDetailSetTabType.Volume
  ): void {
    modalBibliographyDetailRealStore.toggleSet({ bibliographyId, tabType })
  }

  openModalBibliographyRealPrintSelection() {
    this.modalBibliographyRealPrintSelection.open()
  }

  openModalChildCollectionList(): void {
    this.modalChildCollectionList.open({
      collectionId: this.selectedCollection.id,
      onClickTitle: (bibliographyId: number, collectionNo: string) => {
        modalBibliographyDetailStore.setSecondAfterTransitionSource(
          SecondAfterTransitionToBibliographyDetail.ChildCollectionList
        )
        modalBibliographyDetailStore.setInitialSelectCollectionNo(collectionNo)
        this.fetchData(bibliographyId, '')
      }
    })
  }

  openModalConfirmationLendCount(): void {
    this.modalConfirmationLendCount.open({
      bibliographyId: this.bibliographyRealDetail.bibliography.bibliographyId
    })
  }

  openModalShelfDiagram(shelfTypeItem: ShelfTypeItem): void {
    this.$modalShelfDiagram.open({
      shelfType: shelfTypeItem.shelfType,
      holdingBranch: shelfTypeItem.holdingBranch
    })
  }

  openModalUpdateMemo(index: number): void {
    if (this.collectionTableItems[index].isOrder) {
      this.$modalUpdateOrderMemo.open({
        bibliographyRealId: this.bibliographyRealDetail.bibliography
          .bibliographyId,
        orderId: this.collectionTableItems[index].id,
        onUpdatedCallback: () => {
          this.fetchData(
            this.bibliographyRealDetail.bibliography.bibliographyId,
            this.tooliMarcNo
          )
        }
      })
    } else {
      this.$modalUpdateCollectionMemo.open({
        bibliographyRealId: this.bibliographyRealDetail.bibliography
          .bibliographyId,
        collectionId: this.collectionTableItems[index].id,
        onUpdatedCallback: () => {
          this.fetchData(
            this.bibliographyRealDetail.bibliography.bibliographyId,
            this.tooliMarcNo
          )
        }
      })
    }
  }

  openModalSelectionInfo(): void {
    this.modalSelectionInfo.open({
      bibliographyRealId: this.bibliographyRealDetail.bibliography
        .bibliographyId,
      marcNo: this.tooliMarcNo,
      onClickLink: (orderCardId: number) => {
        this.close()
        this.$router.push(`/order-list/${orderCardId}`)
      }
    })
  }

  reset() {
    this.activeTab = BibliographyDetailRealTabType.Collection
    this.tabItem = defaultCollectionDetailTabItem()
    this.collection = defaultCollection()
    this.order = defaultOrder()
    this.bibliographyRealDetail = defaultBibliographyRealDetail()
    this.selectedCollection = defaultBibliographyDetailCollectionTableItem()
  }

  searchCollection(): void {
    this.isOrder ? this.getOrder() : this.getCollection()
  }

  isActiveTab(value: BibliographyDetailRealTabType) {
    return this.activeTab === value
  }

  tabClass(value: BibliographyDetailRealTabType): string {
    return this.activeTab === value ? 'active' : ''
  }

  prev(): void {
    this.pagination(this.currentSearchResultIndex - 1)
  }

  next(): void {
    this.pagination(this.currentSearchResultIndex + 1)
  }

  pagination(index: number): void {
    if (index === -1) return

    if (
      this.pageIsMagazine &&
      [
        SecondAfterTransitionToBibliographyDetail.VolumePagination,
        SecondAfterTransitionToBibliographyDetail.Set
      ].includes(this.secondAfterTransitionSource)
    ) {
      modalBibliographyDetailStore.setSecondAfterTransitionSource(
        SecondAfterTransitionToBibliographyDetail.VolumePagination
      )
    } else {
      modalBibliographyDetailStore.setSecondAfterTransitionSource(
        SecondAfterTransitionToBibliographyDetail.Pagination
      )
    }

    const bibliographyFullIdWithMarcNo: BibliographyFullIdWithMarcNo = {
      prefix: this.searchResults[index].prefix,
      id: this.searchResults[index].bibliographyId,
      marcNo: (this.searchResults[index] as BibliographySearchResultItem).marcNo
    }

    if (bibliographyFullIdWithMarcNo.prefix === Prefix.Real) {
      if (this.tooliSearchEnabled) {
        this.tooliMarcNo = bibliographyFullIdWithMarcNo.marcNo ?? ''
        this.fetchBibliographyTooli()
      }
      if (this.isContentSearch) {
        // eslint-disable-next-line standard/computed-property-even-spacing
        this.contentId = (this.searchResults[
          index
        ] as BibliographySearchResultContentItem).bibliographyContentId
      }
      this.fetchData(
        bibliographyFullIdWithMarcNo.id ?? 0,
        bibliographyFullIdWithMarcNo.marcNo ?? ''
      ).then(() => {
        if (!this.isRegisteredBibliography) {
          this.activeTab = BibliographyDetailRealTabType.Tooli
        }
      })
      return
    }

    this.onToggleSet(bibliographyFullIdWithMarcNo.id ?? 0)
  }

  onClickPrint(): void {
    const element = document.getElementById('modal-bibliography-detail-real')
    if (element) {
      this.$webSocket.sendDialogScreenshotMessage(element)
    } else {
      this.$webSocket.sendScreenshotMessage()
    }
  }

  setScroll(value: number): void {
    this.$nextTick(() => {
      setTimeout(() => {
        const tableScroller: Element | null = document.querySelector(
          '.bibliography-detail-real-scroller'
        )

        if (tableScroller !== null) {
          tableScroller.scrollTo(0, value)
        }
      })
    })
  }

  async getCollection(): Promise<void> {
    try {
      this.collection = await collectionApi.getCollection(
        this.selectedCollection.id
      )
      this.tabItem = {
        basic: {
          collectionNo: this.collection.collectionNo,
          collectionType: this.collection.collectionType,
          opacShow: this.collection.opacShow,
          orderId: 0,
          processedDate: dateTimeToDateFormat(this.collection.processedTime),
          status: this.collection.status,
          handlingType: this.collection.handlingType,
          removeExpectedDate: this.collection.removeExpectedDate,
          orderStatus: defaultSystemCode(),
          processedTime: dateTimeToTimeFormat(this.collection.processedTime),
          storeType: this.collection.storeType,
          removeTime: this.collection.removeTime,
          cancelReason: defaultSystemCode(),
          processedBranchCode: this.collection.processedBranchCode,
          parentCollectionNo: this.collection.parentCollectionNo,
          parentDisplayTitle: this.collection.parentDisplayTitle,
          parentComposedCollectionNo: this.collection
            .parentComposedCollectionNo,
          setNumber: this.collection.setNumber,
          appendixCode: this.collection.appendixCode,
          removeReason: this.collection.removeReason,
          managementFlag: defaultSystemCode(),
          processedPlaceCode: this.collection.processedPlaceCode
        },
        location: {
          holdingBranchCode: this.collection.holdingBranchCode,
          mark: this.collection.mark,
          departmentCode: this.collection.departmentCode,
          ndc: this.collection.ndc,
          shelfTypeOld: this.collection.shelfTypeOld,
          forwardingBranchCode: this.collection.forwardingBranchCode,
          book: this.collection.book,
          specialShelfLimitDate: this.collection.specialShelfLimitDate,
          shelfType: this.collection.shelfType,
          sub: this.collection.sub,
          organizeFlag: false,
          sendFlag: false
        },
        budget: {
          acceptDate: this.collection.acceptDate,
          orderDate: '',
          listPrice: this.collection.listPrice,
          donorCode: this.collection.donorCode,
          budgetExpenseCode: this.collection.budgetExpenseCode,
          acceptType: this.collection.acceptType,
          tempAcceptDate: '',
          evaluationPrice: 0,
          budgetYear: this.collection.budgetYear,
          equipType: this.collection.equipType,
          acceptPrice: this.collection.acceptPrice,
          orderPrice: 0,
          applicantUserId: this.collection.applicantUserId,
          budgetBranchCode: this.collection.budgetBranchCode,
          traderCode: this.collection.traderCode,
          budgetDepartmentCode: this.collection.budgetDepartmentCode
        },
        other: {
          workMemo: this.collection.workMemo,
          workMemoTime: dateTimeToDateFormat(this.collection.workMemoTime),
          workMemoPlaceCode: this.collection.workMemoPlaceCode,
          displayMemo: this.collection.displayMemo,
          displayMemoTime: dateTimeToDateFormat(
            this.collection.displayMemoTime
          ),
          displayMemoPlaceCode: this.collection.displayMemoPlaceCode,
          localMemo: this.collection.localMemo,
          localMemoTime: dateTimeToDateFormat(this.collection.localMemoTime),
          localMemoPlaceCode: this.collection.localMemoPlaceCode,
          checkedDate: this.collection.checkedDate,
          unknownCount: this.collection.unknownCount,
          publishDate: this.collection.publishDate,
          icTagUid: this.collection.icTagUid
        },
        lend: {
          collectionLendBranchCode: this.collection.collectionLendBranchCode,
          borrowingDate: this.collection.borrowingDate,
          lendTotalCount: this.collection.lendTotalCount,
          lendCount3: this.collection.lendCount3,
          collectionLendUserId: this.collection.collectionLendUserId,
          collectionLendPlaceCode: this.collection.collectionLendPlaceCode,
          borrowingDueDate: this.collection.borrowingDueDate,
          lendCount0: this.collection.lendCount0,
          lendCount4: this.collection.lendCount4,
          collectionLendDate: this.collection.collectionLendDate,
          dueDate: this.collection.dueDate,
          remindCount: this.collection.remindCount,
          lendCount1: this.collection.lendCount1,
          lendCount5: this.collection.lendCount5,
          collectionLendType: this.collection.collectionLendType,
          interlibraryLoanCode: this.collection.interlibraryLoanCode,
          remindDate: this.collection.remindDate,
          lendCount2: this.collection.lendCount2
        }
      }
    } catch (error) {
      if (error instanceof AlertMessage) {
        alertStore.setItems(error.alerts)
        this.$modalAlert.open()
      } else if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        this.$modalError.open()
      } else {
        console.error(error)
      }
    }
  }

  async getOrder(): Promise<void> {
    try {
      this.order = await orderApi.getOrder(this.selectedCollection.id)
      this.tabItem = {
        basic: {
          collectionNo: '',
          collectionType: this.order.collectionType,
          opacShow: false,
          orderId: this.order.id,
          processedDate: dateTimeToDateFormat(this.order.processedTime),
          status: defaultSystemCode(),
          handlingType: this.order.handlingType,
          removeExpectedDate: '',
          orderStatus: this.order.status,
          processedTime: '',
          storeType: this.order.storeType,
          removeTime: '',
          cancelReason: this.order.cancelReason,
          processedBranchCode: this.order.processedBranchCode,
          parentCollectionNo: '',
          parentDisplayTitle: this.collection.parentDisplayTitle,
          parentComposedCollectionNo: '',
          setNumber: this.collection.setNumber,
          appendixCode: this.order.appendixCode,
          removeReason: defaultSystemCode(),
          managementFlag: this.order.managementFlag,
          processedPlaceCode: this.order.processedPlaceCode
        },
        location: {
          holdingBranchCode: defaultSystemCode(),
          mark: this.order.mark,
          departmentCode: this.order.departmentCode,
          ndc: this.order.ndc,
          shelfTypeOld: defaultSystemCode(),
          forwardingBranchCode: defaultSystemCode(),
          book: this.order.book,
          specialShelfLimitDate: '',
          shelfType: this.order.shelfType,
          sub: this.order.sub,
          organizeFlag: this.order.organizeFlag,
          sendFlag: this.order.sendFlag
        },
        budget: {
          acceptDate: '',
          orderDate: this.order.orderDate,
          listPrice: this.order.listPrice,
          donorCode: this.order.donorCode,
          budgetExpenseCode: this.order.budgetExpenseCode,
          acceptType: this.order.acceptType,
          tempAcceptDate: this.order.tempAcceptDate,
          evaluationPrice: this.order.evaluationPrice,
          budgetYear: this.order.budgetYear,
          equipType: this.order.equipType,
          acceptPrice: 0,
          orderPrice: this.order.orderPrice,
          applicantUserId: this.order.applicantUserId,
          budgetBranchCode: this.order.budgetBranchCode,
          traderCode: this.order.traderCode,
          budgetDepartmentCode: this.order.budgetDepartmentCode
        },
        other: {
          workMemo: this.order.workMemo,
          workMemoTime: dateTimeToDateFormat(this.order.workMemoTime),
          workMemoPlaceCode: this.order.workMemoPlaceCode,
          displayMemo: this.order.displayMemo,
          displayMemoTime: dateTimeToDateFormat(this.order.displayMemoTime),
          displayMemoPlaceCode: this.order.displayMemoPlaceCode,
          localMemo: this.order.localMemo,
          localMemoTime: dateTimeToDateFormat(this.order.localMemoTime),
          localMemoPlaceCode: this.order.localMemoPlaceCode,
          checkedDate: '',
          unknownCount: 0,
          publishDate: '',
          icTagUid: ''
        },
        lend: {
          collectionLendBranchCode: defaultSystemCode(),
          borrowingDate: '',
          lendTotalCount: 0,
          lendCount3: 0,
          collectionLendUserId: '',
          collectionLendPlaceCode: defaultSystemCode(),
          borrowingDueDate: '',
          lendCount0: 0,
          lendCount4: 0,
          collectionLendDate: '',
          dueDate: '',
          remindCount: 0,
          lendCount1: 0,
          lendCount5: 0,
          collectionLendType: defaultSystemCode(),
          interlibraryLoanCode: defaultSystemCode(),
          remindDate: '',
          lendCount2: 0
        }
      }
    } catch (error) {
      if (error instanceof AlertMessage) {
        alertStore.setItems(error.alerts)
        this.$modalAlert.open()
      } else if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        this.$modalError.open()
      } else {
        console.error(error)
      }
    }
  }

  async fetchData(id: number, marcNo: string): Promise<void> {
    try {
      await this.fetchBibliographyRealDetail(id, marcNo)

      // awaitは必要ない
      this.fetchRealMarcLabel()

      if (this.collectionTableItems.length > 0) {
        let index: number

        if (modalBibliographyDetailStore.initialSelectCollectionNo !== '') {
          index = this.collectionTableItems.findIndex(collection => {
            if (
              modalBibliographySearchStore.bibliographySearchType ===
                BibliographySearchType.Alone &&
              modalBibliographySearchStore.inputAloneSearchItem.searchType ===
                AloneSearchType.CollectionNo &&
              modalBibliographySearchStore.inputAloneSearchItem.collectionNo
                .exceptCheckDigit
            ) {
              return collection.collectionNo.startsWith(
                modalBibliographyDetailStore.initialSelectCollectionNo
              )
            } else {
              return (
                collection.collectionNo ===
                modalBibliographyDetailStore.initialSelectCollectionNo
              )
            }
          })

          modalBibliographyDetailStore.setInitialSelectCollectionNo('')
        } else {
          index = this.collectionTableItems.findIndex(
            collection =>
              collection.collectionNo === this.selectedCollection.collectionNo
          )
        }

        if (~index) {
          this.selectedCollection = this.collectionTableItems[index]
        } else {
          this.selectedCollection = this.collectionTableItems[0]
        }

        this.searchCollection()
      } else {
        this.collection = defaultCollection()
        this.order = defaultOrder()
        this.selectedCollection = defaultBibliographyDetailCollectionTableItem()
      }

      if (this.bibliographyRealDetail.reserves.length > 0) {
        const index: number = this.bibliographyRealDetail.reserves.findIndex(
          reserve => reserve.userId === this.userId
        )

        if (~index) {
          // eslint-disable-next-line standard/computed-property-even-spacing
          this.selectedReserve = this.bibliographyRealDetail.reserves[index]
          this.setScroll(index * 32)
        } else {
          this.selectedReserve = this.bibliographyRealDetail.reserves[0]
        }
      } else {
        this.selectedReserve = defaultBibliographyRealDetailReserve()
      }

      this.calculateTableHeight()
    } catch (error) {
      if (error instanceof AlertMessage) {
        alertStore.setItems(error.alerts)
        this.$modalAlert.open()
      } else if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        this.$modalError.open()
      } else {
        console.error(error)
      }
    }
  }

  // 渡されたidとmarcNoのどちらかをapi呼出に使用する仕様
  async fetchBibliographyRealDetail(id: number, marcNo: string): Promise<void> {
    try {
      this.bibliographyRealDetail = await bibliographyRealApi.getBibliography(
        id > 0 ? id : undefined,
        marcNo || undefined
      )
    } catch (error) {
      if (error instanceof AlertMessage) {
        alertStore.setItems(error.alerts)
        this.$modalAlert.open()
      } else if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        this.$modalError.open()
      } else {
        console.error(error)
      }
      this.close()
    }
  }

  async fetchBibliographyTooli(): Promise<void> {
    if (this.tooliMarcNo === '') {
      this.tooliInfo = defaultBibliographyTooli()
      return
    }

    try {
      this.tooliInfo = await bibliographyRealApi.getBibliographyTooli(
        this.tooliMarcNo
      )
      this.mergeTooliData()
    } catch (error) {
      if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        this.$modalError.open()
      } else {
        console.error(error)
      }
    }
  }

  async fetchRealMarcLabel(): Promise<void> {
    const searchType: SearchType = this.pageIsBook
      ? SearchType.Book
      : this.pageIsAv
      ? SearchType.Av
      : SearchType.Magazine

    try {
      this.realFirstMarcLabels = await marcLabelApi.getAll(
        BibliographyClass.Real,
        { ...defaultSystemCode(), code: searchType },
        false
      )
    } catch (error) {
      if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        this.$modalError.open()
      } else {
        console.error(error)
      }
    }
  }

  async receiptPrint(single: boolean) {
    try {
      const receiptData = await bibliographyRealApi.getReceiptInfo(
        this.bibliographyRealDetail.bibliography.bibliographyId,
        single && this.selectedCollection.id > 0
          ? this.selectedCollection.id
          : undefined
      )

      this.$webSocket.sendReceiptPrintMessage({
        command: CommandType.ReceiptPrintBibliography,
        name: ReceiptPrintName.ReceiptPrintBibliography,
        data: receiptData,
        subject: `書誌番号：${this.bibliographyRealDetail.bibliography.prefix +
          this.bibliographyRealDetail.bibliography.bibliographyId
            .toString()
            .padStart(10, '0')}`
      })
    } catch (error) {
      if (error instanceof AlertMessage) {
        alertStore.setItems(error.alerts)
        this.$modalAlert.open()
      } else if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        this.$modalError.open()
      } else {
        console.error(error)
      }
    }
  }

  mergeTooliData() {
    if (this.bibliographyRealDetail.bibliography.displayClass === '') {
      this.bibliographyRealDetail.bibliography.displayClass = systemParameterStore.displayNdc(
        this.tooliInfo.ndc8,
        this.tooliInfo.ndc9,
        this.tooliInfo.ndc10
      )
    }
    if (this.bibliographyRealDetail.bibliography.displayTitle === '') {
      this.bibliographyRealDetail.bibliography.displayTitle = this.tooliInfo.title2
    }
    if (this.bibliographyRealDetail.bibliography.displayAuthor === '') {
      this.bibliographyRealDetail.bibliography.displayAuthor = this.tooliInfo.author
    }
    if (this.bibliographyRealDetail.bibliography.displayPublisher === '') {
      const series = this.tooliInfo.series ? `（${this.tooliInfo.series}）` : ''
      this.bibliographyRealDetail.bibliography.displayPublisher =
        this.tooliInfo.publisher + series
    }
    if (this.bibliographyRealDetail.bibliography.displayPublished === '') {
      this.bibliographyRealDetail.bibliography.displayPublished = this.tooliInfo.pubYear
    }
  }

  onClickAutoLib(): void {
    alertStore.setItem(
      AlertFactory.create(
        AlertCodeCLT00050,
        `資料番号：${this.selectedCollection.collectionNo}の出庫`
      )
    )
    this.$modalAlert.open({
      onOkClick: () => {
        this.$webSocket.sendAutoLib({
          collectionNo: this.selectedCollection.collectionNo,
          retrievalStationCode: this.autoLibRetrievalStationCode
        })
      }
    })
  }

  printBibliographyList() {
    const currentActiveTab = this.activeTab
    this.activeTab = BibliographyDetailRealTabType.Bibliography

    this.$nextTick(() => {
      const area = (document.getElementById(
        'bibliography-tag-data-list'
      ) as HTMLInputElement).outerHTML

      let head = ''

      const links = document.getElementsByTagName('link')
      for (let i = 0; i < links.length; i++) {
        head += links[i].outerHTML
      }
      const styles = document.getElementsByTagName('style')
      for (let i = 0; i < styles.length; i++) {
        head += styles[i].outerHTML
      }
      head += `<link rel="stylesheet" href="/css/bibliography_list_print.css">`

      /* eslint-disable no-useless-escape */
      const script = `<script>window.print();window.close();<\/script>`

      const sub = window.open() as Window
      sub.document.write(
        '<html><head>' +
          head +
          '</head><body>' +
          area +
          script +
          '</body></html>'
      )

      this.activeTab = currentActiveTab
    })
  }
}
